import React, { PropTypes } from 'react'

import ReportButton from './ReportButton'
import config from 'config'
import styles from './PracticeItem.css'


function PracticeItem ({
  pid,
  qid,
  name,
  videoDisplay,
  videoHighlight,
  answered,
  reportStatus,
  answerId
}) {
  return (
    <div className={styles.row}>
      <div className={styles.title}>
        <i className="icon-practice"></i>
        <span>{name}</span>
      </div>
      <div className={styles.blank}></div>
      <div className={styles.reports}>
        {
          answered && <span className={styles.report}>报告</span>
        }
        <ReportButton status={reportStatus} answerId={answerId}></ReportButton>
      </div>
      <div className={styles.buttons}>
        <a
          className={styles.button}
          target="_blank"
          href={`practice/${pid}/question/${qid}`}
        >
          {answered ? '重新作答' : '立即练习'}
        </a>
        {
          videoDisplay && (
            videoHighlight ?
              <a
                className={styles.button}
                href={`${config.site.zhike}/play/${pid || qid}?ctqaType=${pid ? 'practice' : 'question'}`}
                target="_blank"
              >
                视频详解
              </a> :
              <a className={styles.buttonDarken} href={`${config.site.zhike}/ctqa/0`} target="_blank">
                视频详解
              </a>
          )
        }
      </div>
    </div>
  )
}

PracticeItem.proptypes = {
  pid: PropTypes.number.isRequired,
  qid: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  videoDisplay: PropTypes.bool.isRequired,
  videoHighlight: PropTypes.bool.isRequired,
  answered: PropTypes.bool.isRequired,
  reportStatus: PropTypes.number.isRequired,
  answerId: PropTypes.number.isRequired
}


export default PracticeItem



/** WEBPACK FOOTER **
 ** ./src/components/QuestionList/PracticeItem.js
 **/